<template>
  <div class="flex flex-col gap-1 md:gap-2">
    <Divider class="w-auto mx-0" />
    <div class="flex justify-between gap-1 items-center">
      <p class="title-sm text-primary30">{{ item.subtitle }}</p>
      <p class="title-sm text-primary30">
        {{ item.started }}{{ item.finished ? item.finished : '' }}
      </p>
    </div>
    <p class="title-md">
      {{ item.title }}
    </p>
    <p class="body-md text-neutral20">
      {{ item.description }}
    </p>
  </div>
</template>

<script>
import Divider from '@/Components/Divider'
import { validateRequiredKeys } from '@/utilities.helpers.js'

export default {
  name: 'ProfileListItem',
  components: { Divider },
  props: {
    item: {
      required: true,
      validator: value =>
        validateRequiredKeys(value, ['title', 'subtitle', 'started', 'description']),
    },
  },
}
</script>

<style></style>
